import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaChevronDown,
  FaChevronUp,
  FaPlus,
  FaEdit,
  FaUserCircle,
  FaClock,
  FaBriefcase,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/GlobalStyles.css";

/* ================= SECTIONS ================= */

const rightSections = [
  { key: "workPreferences", title: "Job Preference", percent: "25%" },
  { key: "experience", title: "Work Experience", percent: "15%" },
  { key: "education", title: "Education Details", percent: "15%" },
  { key: "skills", title: "Skills", percent: "10%" },
  { key: "qualification", title: "Professional Qualification", percent: "5%" },

];


const emptyUser = {
  name: "",
  gender: "",
  address: {},
  profilePic: "",
  work_preference: null,
  work_experience: [],
  education: [],
  skills: [],
  qualification: [],

};

const LandingPage = ({ user, openAdd, openEdit }) => {
  const safeUser = user || emptyUser;
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const handleLookForJobs = () => {
    navigate("/jobs");
    // const wp = safeUser.work_preference;
    // if (!wp) {
    //   navigate("/jobs");
    //   return;
    // }

    // const params = new URLSearchParams();

    // // Teaching / Non-teaching
    // if (wp.role_teaching) {
    //   params.set("category", "teaching");
    // } else if (wp.role_non_teaching) {
    //   params.set("category", "non-teaching");
    // }

    // // Domain (school / edtech / college-university)
    // if (wp.domain) {
    //   params.set("category", wp.domain.toLowerCase().replace(/\s+/g, "-"));
    // }

    // // Location
    // const location =
    //   wp.preferred_location ||
    //   wp.city ||
    //   safeUser.address?.city;

    // if (location) {
    //   navigate(`/jobs/${location.toLowerCase()}?${params.toString()}`);
    // } else {
    //   navigate(`/jobs?${params.toString()}`);
    // }
  };

  const toggle = (key) => {
    setOpen(open === key ? null : key);
  };

  /* ================= EDUCATION MAP ================= */



  /* ================= DETAIL RENDERERS ================= */

  const renderWorkPreference = () => {
    const wp = safeUser.work_preference;
    // Basic check if preference exists (e.g. has a role or domain or category)
    if (!wp || (!wp.role_teaching && !wp.role_non_teaching && !wp.role && !wp.domain)) {
      return null;
    }

    return (
      <div className="profile-grid">
        <div className="detail-card pre-school-card">
          <div className="card-header-row">
            <h4 className="card-header-title">
              {wp.role_teaching || wp.role_non_teaching || wp.role || "Role"} {wp.domain ? `for ${wp.domain}` : ""}
            </h4>
            <button className="edit-icon-btn" onClick={() => openEdit("workPreferences", wp)}>
              <FaEdit />
            </button>
          </div>

          <div className="card-info-grid">
            <div className="info-item">
              <FaClock className="info-icon" />
              <span>
                {wp.experience === 0
                  ? "Fresher"
                  : wp.experience
                    ? `${wp.experience} Years`
                    : "—"}
              </span>
            </div>

            <div className="info-item">
              <FaBriefcase className="info-icon" />
              <span>{wp.employment_type || "—"}</span>
            </div>


            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <span>{wp.preferred_location || wp.city || "—"}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderExperience = () => {
    if (!safeUser.work_experience.length) return null;

    return (
      <div className="profile-grid">
        {safeUser.work_experience.map((e) => (
          <div key={e._id} className="detail-card">
            <strong>{e.position}</strong>
            <div>{e.organisation}</div>

            <div className="detail-row">
              <span className="label">Duration:</span>
              <span className="value">
                {new Date(e.start_date).toLocaleDateString()} –{" "}
                {e.working_till_date
                  ? "Present"
                  : new Date(e.end_date).toLocaleDateString()}
              </span>
            </div>

            <div className="detail-row">
              <span className="label">Employment:</span>
              <span className="value">{e.employment_type}</span>
            </div>

            <div className="detail-row">
              <span className="label">Location:</span>
              <span className="value">{e.city}, {e.country}</span>
            </div>

            <button
              className="edit-inline-btn"
              onClick={() => openEdit("experience", e)}
            >
              <FaEdit /> Edit
            </button>
          </div>
        ))}
      </div>
    );
  };

  /* ================= EDUCATION ================= */

  const renderEducation = () => {
    if (!safeUser.education.length) {
      return <p className="accordion-placeholder">No education details added yet.</p>;
    }

    return (
      <div className="education-grid">
        {safeUser.education.map((e) => {
          const isSchool = e.education === "10th" || e.education === "12th";

          return (
            <div key={e._id} className="detail-card">
              <div className="detail-row" style={{ justifyContent: "space-between" }}>
                <strong>
                  {e.education === "10th"
                    ? "Class 10th"
                    : e.education === "12th"
                      ? "Class 12th"
                      : e.education === "graduation"
                        ? "Graduation / Diploma"
                        : e.education === "masters"
                          ? "Masters / Post-Graduation"
                          : "PhD / Doctorate"}
                </strong>

                <button
                  className="edit-inline-btn"
                  onClick={() => openEdit("education", e)}
                >
                  <FaEdit /> Edit
                </button>
              </div>

              {isSchool ? (
                <>
                  <div className="detail-row">
                    <span className="label">Board:</span>
                    <span className="value">{e.board}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Institution:</span>
                    <span className="value">{e.institution_name}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Country:</span>
                    <span className="value">{e.country}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Year:</span>
                    <span className="value">{e.year_of_passing}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Grade:</span>
                    <span className="value">{e.grade}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="detail-row">
                    <span className="label">Field:</span>
                    <span className="value">{e.field_of_study}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Institution:</span>
                    <span className="value">{e.institution_name}</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Duration:</span>
                    <span className="value">
                      {new Date(e.start_date).getFullYear()} –{" "}
                      {e.end_date ? new Date(e.end_date).getFullYear() : "Present"}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Grade:</span>
                    <span className="value">{e.grade}</span>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  /* ================= SKILLS ================= */

  const renderSkills = () => {
    if (!safeUser.skills.length) {
      return <p className="accordion-placeholder">No skills added yet.</p>;
    }

    return (
      <div className="profile-grid">
        <div className="detail-card skill-card">
          <strong>Skills</strong>

          <div className="skill-list">
            {safeUser.skills.map((s, i) => {
              const skillName = typeof s === 'string' ? s : (s.skill || s.name);
              return (
                <span
                  key={i}
                  className="skill-pill-interactive"
                  onClick={() => openEdit("skills", s)}
                >
                  {skillName}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    );
  };


  /* ================= QUALIFICATIONS ================= */

  const renderQualifications = () => {
    // Qualification is a SINGLE OBJECT in the backend now, not an array
    const q = safeUser.qualification;
    if (!q || !q.qualification) {
      return <p className="accordion-placeholder">No qualifications added.</p>;
    }
    return (
      <div className="profile-grid">
        <div className="detail-card skill-card">
          <strong>Professional Qualifications</strong>
          <div className="skill-list">
            {/* passed as single object to edit */}
            <span className="skill-pill-interactive" onClick={() => openEdit("qualification", q)}>
              {q.qualification}
            </span>
          </div>
        </div>
      </div>
    );
  };

  /* ================= CERTIFICATIONS ================= */


  //

  const renderBody = (key) => {
    switch (key) {
      case "workPreferences":
        return renderWorkPreference();
      case "experience":
        return renderExperience();
      case "education":
        return renderEducation();
      case "skills":
        return renderSkills();
      case "qualification":
        return renderQualifications();

      default:
        return null;
    }
  };

  /* ================= UI ================= */

  return (
    <>
      <Navbar />
      <div className="h-[96px]" />

      <div className="page-container">

        <div className="max-w-[1180px] mx-auto px-4">
          <div className="profile-dashboard-grid">


            {/* LEFT */}
            <div className="profile-card">
              <div className="accordion-header">
                <h3 className="section-header">Personal Information</h3>

                <button
                  className="add-btn"
                  onClick={() =>
                    openEdit("personalProfile", {
                      ...safeUser,

                      street: safeUser.address?.street || "",
                      area: safeUser.address?.area || "", // ✅ Added Area
                      city: safeUser.address?.city || "",
                      state: safeUser.address?.state || "",
                      postal_code: safeUser.address?.postal_code || "",
                      country: safeUser.address?.country || "",
                    })
                  }
                >
                  <FaEdit /> Edit
                </button>

              </div>

              <div className="flex gap-3.5 items-center">
                {safeUser.profilePic ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${safeUser.profilePic}`}
                    className="profile-avatar"
                    alt="Profile"
                  />
                ) : (
                  <FaUserCircle size={64} color="#CBD5E1" />
                )}

                <div>
                  <strong>{safeUser.name || "—"}</strong>
                  <div>{safeUser.gender || "—"}</div>
                  {console.log("safeUser:", safeUser)}
                  {console.log("safeUser city:", safeUser.address.city)}
                  {console.log("safeUser.address:", safeUser.address)}
                  <div>{safeUser.address?.area ? `${safeUser.address.area}, ` : ""}{safeUser.address?.city ? `${safeUser.address.city}, India` : "—"}</div>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div>
              {rightSections.map((section) => (
                <div key={section.key} className="accordion-card">
                  <div className="accordion-header">
                    <div className="accordion-title" onClick={() => toggle(section.key)}>
                      {open === section.key ? <FaChevronUp /> : <FaChevronDown />}
                      {section.title}
                    </div>

                    <div className="accordion-actions">
                      <span className="percent-badge">{section.percent}</span>

                      {/* WORK PREFERENCES */}
                      {section.key === "workPreferences" ? (
                        safeUser.work_preference &&
                          (safeUser.work_preference.role_teaching ||
                            safeUser.work_preference.role_non_teaching ||
                            safeUser.work_preference.role ||
                            safeUser.work_preference.domain) ? (
                          <button className="add-btn" onClick={() => openEdit(section.key, safeUser.work_preference)}>
                            <FaEdit /> Edit
                          </button>
                        ) : (
                          <button className="add-btn" onClick={() => openAdd(section.key)}>
                            <FaPlus /> Add
                          </button>
                        )
                      ) : section.key === "qualification" ? (
                        /* QUALIFICATION (Single Object) */
                        safeUser.qualification && safeUser.qualification.qualification ? (
                          <button className="add-btn" onClick={() => openEdit(section.key, safeUser.qualification)}>
                            <FaEdit /> Edit
                          </button>
                        ) : (
                          <button className="add-btn" onClick={() => openAdd(section.key)}>
                            <FaPlus /> Add
                          </button>
                        )
                      ) : (
                        /* DEFAULT (Arrays: Experience, Education, etc.) - Always Add New */
                        <button className="add-btn" onClick={() => openAdd(section.key)}>
                          <FaPlus /> Add
                        </button>
                      )}
                    </div>
                  </div>

                  {open === section.key && (
                    <div className="accordion-body">
                      {renderBody(section.key) || (
                        <p className="accordion-placeholder">
                          Click Add to complete this section.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              ))}

              <div className="my-10 text-center">
                <button className="primary-btn" onClick={handleLookForJobs}>
                  Look For Jobs!
                </button>

              </div>
            </div>

          </div>
        </div>
      </div>


      <Footer />
    </>
  );
};

export default LandingPage;
